<div class="padding-24 pos-r" *ngIf="tickets.ticketsLoading">
  <app-loader></app-loader>
</div>

<div class="matrix__list" *ngIf="!tickets.ticketsLoading">
  <div class="matrix__list-date" *ngFor="let date of tickets.dataMatrix; let first = first; let last = last">
    <ng-container *ngIf="date.edo_intervals.isShow && date.edo_intervals.tickets && date.edo_intervals.tickets.length">
      <div class="gp__tickets-header">
        <div class="grid grid--gap-4">
          <div class="grid__box grid__box--size-min">
            <div class="grid grid--gap-4 cur-pointer" (click)="changeOpenedIntervals(date.edo_intervals)">
              <div class="grid__box grid__box--size-min" *ngIf="date.edo_intervals.isOpen">
                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min" *ngIf="!date.edo_intervals.isOpen">
                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="ml-8">
              <app-icon [glyph]="'doc'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </div>
          <div class="grid__box grid__box--size-min font-weight-bold">
            Исправление договоров (
            {{ date.edo_intervals.tickets.length }} )
          </div>
        </div>
      </div>
      <ng-container *ngIf="date.edo_intervals.isShow && date.edo_intervals.isOpen">
        <div class="tickets">
          <div class="tickets__column" *ngFor="let ticket of date.edo_intervals.tickets; let ticketIndex = index">
            <app-tickets-ticket-edo
              *ngIf="ticket.isShow"
              [ticket]="ticket"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [filter]="filter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
            >
            </app-tickets-ticket-edo>
          </div>
        </div>
        <div class="matrix__line-separator"></div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="date.gp_intervals.isShow && date.gp_intervals.tickets && date.gp_intervals.tickets.length">
      <div class="gp__tickets-header">
        <div class="grid grid--gap-4">
          <div class="grid__box grid__box--size-min">
            <div class="grid grid--gap-4 cur-pointer" (click)="changeOpenedIntervals(date.gp_intervals)">
              <div class="grid__box grid__box--size-min" *ngIf="date.gp_intervals.isOpen">
                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min" *ngIf="!date.gp_intervals.isOpen">
                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="ml-8">
              <app-icon [glyph]="'triangle-warning'" [size]="'16'" [color]="'red-dark'"></app-icon>
            </div>
          </div>
          <div class="grid__box grid__box--size-min font-weight-bold">
            Аварии на коммутаторах (
            {{ date.gp_intervals.tickets.length }} )
          </div>
        </div>
      </div>
      <ng-container *ngIf="date.gp_intervals.isShow && date.gp_intervals.isOpen">
        <div class="tickets">
          <div class="tickets__column" *ngFor="let ticket of date.gp_intervals.tickets; let ticketIndex = index">
            <app-tickets-ticket-gp
              *ngIf="ticket.isShow"
              [ticket]="ticket"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [filter]="filter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
            >
            </app-tickets-ticket-gp>
          </div>
        </div>
        <div class="matrix__line-separator"></div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="date.intervals.isShow">
      <div class="intervals__wrapper" #intervalsWrapper>
        <div class="intervals" #intervals>
          <div class="intervals__column" *ngFor="let interval of date.intervals.intervals; let first = first">
            <div class="interval__column-date" *ngIf="first">
              <span *ngIf="date.date === currentDate">Сегодня</span>
              <span *ngIf="date.date !== currentDate">{{ date.date | dateFormat: 'DD.MM.YYг.' }}</span>
            </div>
            <div class="interval__column-time">
              {{ interval.interval }}
            </div>
          </div>
        </div>
      </div>
      <div class="tickets">
        <div class="tickets__column" *ngFor="let interval of date.intervals.intervals; let intervalIndex = index">
          <ng-container *ngFor="let ticket of interval.tickets">
            <app-tickets-ticket
              *ngIf="ticket.isShow"
              [intervalIndex]="intervalIndex"
              [ticket]="ticket"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [filter]="filter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
            >
            </app-tickets-ticket>
          </ng-container>
        </div>
      </div>
      <div class="matrix__line-separator" *ngIf="!last"></div>
    </ng-container>
  </div>
  <ng-container *ngIf="!tickets.dataMatrix || (tickets.dataMatrix && !tickets.dataMatrix.length)">
    <div class="padding-24 ta-center text-italic color-gray-dark">"Заявки по заданным критериям не найдены".</div>
  </ng-container>
</div>
